import allPoints from "../../../assets/images/all_points.svg";
import pulse from "../../../assets/images/pulse.svg"; 
import starNetwork from "../../../assets/images/star_network.svg";
import nyce from "../../../assets/images/nyce_network.svg";
import moneyPass from "../../../assets/images/money_pass.svg";
import usdIcon from "../../../assets/images/USD.svg";
import gbpIcon from "../../../assets/images/GBP.svg";
import pkrIcon from "../../../assets/images/Pkr-flag.svg";
import masterCard from "../../../assets/images/Cards-icons/mastercard.svg";
import visaCard from "../../../assets/images/Cards-icons/visa.svg";
import cirrus from "../../../assets/images/Cards-icons/cirrus.svg";
import maestro from "../../../assets/images/Cards-icons/maestro.svg";
import visaPlus from "../../../assets/images/Cards-icons/visa-plus.svg";
import interlink from "../../../assets/images/Cards-icons/interlink.svg";
import blackhawak from "../../../assets/images/Cards-icons/blackhawak.svg";
import cardPlaceholder from "../../../assets/images/card-placeholder.svg";
import discover from "../../../assets/images/Cards-icons/discover.svg";
import americanExpress from "../../../assets/images/Cards-icons/amex.svg";
import unionPay from "../../../assets/images/Cards-icons/unionpay.svg";


export const cardTechnology = [
  { label: "EMV Chip & PIN", value: 0 },
  { label: "Contactless EMV", value: 1 },
  { label: "Magstripe", value: 2 },
  { label: "Contactless Magstripe", value: 3 },
  { label: "Other", value: 4 },
];
export const tempCard = {
  cards: [
    {
      label: "Discover®",
      value: "Discover",
    },
    {
      label: "American Express®",
      value: "American Express",
    },
    {
      label: "UnionPay®",
      value: "UnionPay",
    },
    {
      label: "Closed Loop",
      value: "Closed Loop",
    },
  ],
  closedLoop: [
    {
      label: "Blackhawk Networks®",
      value: "Blackhawk Networks",
    },
    {
      label: "Others",
      value: "Others",
    },
  ],
};
export const atm_networks = [
  {
    label: "STAR® Network",
    value: 0,
    icon: starNetwork,
  },
  {
    label: "NYCE Network",
    value: 1,
    icon: nyce,
  },
  {
    label: "Money Pass",
    value: 2,
    icon: moneyPass,
  },
  {
    label: "All Point",
    value: 3,
    icon: allPoints,
  },
  {
    label: "PULSE",
    value: 4,
    icon: pulse,
  },
  {
    label: "Other",
    value: 5,
    icon: cardPlaceholder,
  },
];

export const subBin = [
  {
    value: "10",
    label: "10",
  },
  {
    value: "100",
    label: "100",
  },
  
  {
    value: "other",
    label: "Other",
  },
  {
    value: "n/a",
    label: "N/A",
  },
];

export const cardInfo = [
  { label: "Sent via email", value: 0 },
  { label: "Displayed on the mobile app", value: 1 },
  { label: "Displayed on the cardholder website", value: 2 },
  { label: "I2c Hosted SDK", value: 3 },
  { label: "Other", value: 4 },
];

export const cardNumberOptions = [
  {
    value: "Same Card Number",
    label:
      "Virtual card will be closed when the physical card is received and activated by the consumer.",
  },
  {
    value: "Different Card Numbers",
    label: "Both cards will remain active.",
  },
];

export const cardOptions = [
  {
    label: "Virtual Cards",
    value: "virtual-cards",
    supportText:
      "Only virtual cards will be issued for online transactions. These will not be provisioned to a physical card or payment device.",
  },
  {
    label: "Physical Cards",
    value: "physical-cards",
    supportText: "Account provisioned to a physical card only.",
  },
  {
    label: "Both Virtual and Physical Cards (On Demand)",
    value: "virtual-and-physical-on-demand",
    supportText:
      "Issue a virtual card and initiate the physical card issuance process at the same time.",
  },
  {
    label: "Both Virtual and Physical Cards (Simultaneous Issuance)",
    value: "virtual-and-physical-simultaneous",
    supportText:
      "Issue a virtual card and issue a physical card if requested by the consumer.",
  },
  { label: "N/A", value: "n/a", supportText: "" },
];
export const currencies = [
  {
    value: "USD",
    icon: usdIcon,
  },
  {
    value: "GBP",
    icon: gbpIcon,
  },
  {
    value: "PKR",
    icon: pkrIcon,
  },
];

export const masterCardNetwork = [
  { label: "Mastercard", value: 0, icon: masterCard },
  { label: "Cirrus", value: 1, icon: cirrus },
  { label: "Maestro", value: 2, icon: maestro },
];
export const visaCardNetwork = [
  { label: "VISA", value: 3, icon: visaCard },
  { label: "Interlink", value: 4, icon: interlink },
  { label: "PLUS", value: 5, icon: visaPlus },
];
export const otherCardNetwork = [
  { label: "Discover ®", value: 6, icon: discover },
  { label: "American Express ®", value: 7, icon: americanExpress },
  { label: "UnionPay ®", value: 8, icon: unionPay },
  { label: "Blackhawk Network", value: 9, icon: blackhawak },
  { label: "Other", value: 10, icon: cardPlaceholder },
];
// export const region = ["US", "Pakistan", "Canada"];
export const region = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];
export const binType = [
  { label: "New BIN", value: 0 },
  { label: "Existing BIN", value: 1 },
  { label: "N/A", value: 2 },
];

export const binInformation = [
  { label: "BID", value: 0 },
  { label: "ICA", value: 1 },
  { label: "N/A", value: 2 },
];

export const masterCardBillingUpdater = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "N/A", value: "n/a" },
];

export const visaBillingUpdater = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "N/A", value: "n/a" },
];